interface NoResultProps {
  text: string;
}

const NoResult = ({ text }: NoResultProps) => {
  return (
    <div className="w-full h-[102px] px-5 py-10 rounded-lg justify-center items-center gap-2.5 inline-flex">
      <div className="text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
        {text}
      </div>
    </div>
  );
};

export default NoResult;
